import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SettingResult } from 'src/app/core/settings/settings.service';
import { ActivatedRoute } from '@angular/router';
import categoryDescriptions from './category-descriptions.json';

@Component({
  selector: 'category-cell',
  template: `<div class="category-cell">
      <span class="category-cell__text" title="{{description}}"> {{category}}</span>
    </div>
  `,
  styleUrls: ['./category-cell.component.scss']
})
export class CategoryCellComponent implements ICellRendererAngularComp {
  settingResult: SettingResult;
  category: string;
  description: string;
  clickable: boolean = false;
  entityId: string;

  constructor(private readonly activatedRoute: ActivatedRoute) { }

  agInit(params: any): void {
    this.refresh(params);
  }

  refresh(params: any): boolean {
    this.category = params.node.data.category;
    this.description = categoryDescriptions[params.node.data.category];
    return true;
  }
}
